import React, { FC } from 'react';
import { FormikHelpers } from 'formik';
import DateTime from '../../../../library/inputs/dateTime/DateTime';

interface Props {
  id: string;
  enabled: boolean;
  placeholder: string | undefined;
  value: string;
  touched: boolean | undefined;
  error: string | undefined;
  setFieldTouched: FormikHelpers<string>['setFieldTouched'];
  setFieldValue: FormikHelpers<string>['setFieldValue'];
  readOnlyMode?: boolean;
}

const BirthDateField: FC<Props> = ({
  id,
  enabled,
  placeholder,
  value,
  touched,
  error,
  setFieldTouched,
  setFieldValue,
  readOnlyMode,
}: Props) => {
  return (
    <DateTime
      id={id}
      enabled={enabled}
      placeholder={placeholder}
      value={value}
      touched={touched}
      error={error}
      mode="birthdate"
      onClose={() => setFieldTouched(id, true, true)}
      onChange={async (val) => await setFieldValue(id, val, true)}
      readOnlyMode={readOnlyMode}
    />
  );
};

export default BirthDateField;
